import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api`;

export async function search(params: any) {
  const { series, topic, resource_type, grade, ...rest } = params || {};
  const formParams: any = { ...rest };
  if (Array.isArray(topic) && topic.length > 0) {
    topic.forEach((t: string, i: number) => {
      formParams[`topic[${i}]`] = t;
    });
  }
  if (Array.isArray(series) && series.length > 0) {
    series.forEach((s: string, i: number) => {
      formParams[`series[${i}]`] = s;
    });
  }
  if (Array.isArray(resource_type) && resource_type.length > 0) {
    resource_type.forEach((t: string, i: number) => {
      formParams[`resource_type[${i}]`] = t;
    });
  }
  if (Array.isArray(grade) && grade.length > 0) {
    grade.forEach((g: string, i: number) => {
      formParams[`grade[${i}]`] = g;
    });
  }
  return client.post({
    url: `${url}/platform_resource/search`,
    form: formParams
  });
}
export async function getInitialList(params: any) {
  return client.post({
    url: `${url}/course/get_menu`,
    form: {
      ...params
    }
  });
}
export async function getQR(params: any) {
  return client.post({
    url: `${url}/platform_resource/show_qr_code`,
    form: {
      ...params
    }
  });
}
// 储存至收藏清单
export async function addFavorite(params: any) {
  return client.post({
    url: `${url}/platform_resource/add_favourite`,
    form: {
      ...params
    }
  });
}
// 取消收藏
export async function cancelFavorite(params: any) {
  return client.post({
    url: `${url}/platform_resource/delete_favourite`,
    form: {
      ...params
    }
  });
}
// 预览档案
export async function previewFile(params: any) {
  return client.post({
    url: `${url}/platform_resource/get_main`,
    form: {
      ...params
    }
  });
}
// AI搜寻
export async function getAISearch(params: any) {
  const { series, topic, resource_type, grade, ...rest } = params || {};
  const formParams: any = { ...rest };
  if (Array.isArray(topic) && topic.length > 0) {
    topic.forEach((t: string, i: number) => {
      formParams[`topic[${i}]`] = t;
    });
  }
  if (Array.isArray(series) && series.length > 0) {
    series.forEach((s: string, i: number) => {
      formParams[`series[${i}]`] = s;
    });
  }
  if (Array.isArray(resource_type) && resource_type.length > 0) {
    resource_type.forEach((t: string, i: number) => {
      formParams[`resource_type[${i}]`] = t;
    });
  }
  if (Array.isArray(grade) && grade.length > 0) {
    grade.forEach((g: string, i: number) => {
      formParams[`grade[${i}]`] = g;
    });
  }
  return client.post({
    url: `${url}/platform_resource/ai_search`,
    form: formParams
  });
}

// 获取主题分类标签
export async function getTopicTags(params: { topic?: string[]; type?: string; keyword?: string }) {
  const formParams: any = {};
  // 将数组转换为 topic[0], topic[1]... 格式
  if (params.topic && params.topic.length > 0) {
    params.topic.forEach((t, i) => {
      formParams[`topic[${i}]`] = t;
    });
  }
  if (params.type) {
    formParams.type = params.type;
  }
  if (params.keyword) {
    formParams.keyword = params.keyword;
  }
  return client.post({
    url: `${url}/platform_resource/get_topic_tags`,
    form: formParams
  });
}

// 获取教学系列（series facet）
export async function getSeries(params: {
  type: string;
  keyword?: string;
  grade?: string[];
  lang?: string;
  resource_type?: string[];
}) {
  const formParams: any = {
    type: params.type
  };
  if (params.keyword) {
    formParams.keyword = params.keyword;
  }
  if (params.lang) {
    formParams.lang = params.lang;
  }
  if (params.grade && params.grade.length > 0) {
    params.grade.forEach((g, i) => {
      formParams[`grade[${i}]`] = g;
    });
  }
  if (params.resource_type && params.resource_type.length > 0) {
    params.resource_type.forEach((t, i) => {
      formParams[`resource_type[${i}]`] = t;
    });
  }
  return client.post({
    url: `${url}/platform_resource/get_series`,
    form: formParams
  });
}
